export default "__VITE_ASSET__jYvR5ZWC__"